'use client';

import dynamic from 'next/dynamic';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { useEffect, useState } from 'react';
import { LocationAccessComponentDiv } from './LocationAccessPopup';

/* Lazy: this hook chain is reachable from the footer on every page, so a static
   import puts the listing's JS+CSS in the base bundle. It renders only after a
   second click (allow/deny/country), and is empty until its own API call. */
const RetailStoreListingComponentDiv = dynamic(
  () =>
    import('./RetailStoreListing').then(
      (m) => m.RetailStoreListingComponentDiv,
    ),
  { ssr: false },
);

export const StoreLocatorComponentDiv = () => {
  const { region: country } = useRegionLocale();

  const [countryChosen, setCountryChosen] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<GeolocationPosition | null>(
    null,
  );
  const [chosenFlow, setChosenFlow] = useState<string | null>(null);

  // Warm the listing chunk while the user is still on the allow/deny step, so
  // the lazy import above costs no visible gap once they choose.
  useEffect(() => {
    void import('./RetailStoreListing');
  }, []);

  useEffect(() => {
    if (userLocation?.coords) {
      setChosenFlow('LOCATION_PERMISSION_GIVEN');
      console.log(userLocation.coords.latitude, userLocation.coords.longitude);
    }
  }, []);

  useEffect(() => {
    if (!countryChosen && country) {
      setCountryChosen(country);
    }
  }, [country]);

  switch (chosenFlow) {
    case 'LOCATION_PERMISSION_GIVEN':
      return (
        <RetailStoreListingComponentDiv
          setCountry={setCountryChosen}
          setFlow={setChosenFlow}
          chosenCountry={countryChosen}
          userLoc={userLocation}
        />
      );
    case 'LOCATION_PERMISSION_DENIED':
      return (
        <RetailStoreListingComponentDiv
          setCountry={setCountryChosen}
          setFlow={setChosenFlow}
          chosenCountry={countryChosen}
          userLoc={userLocation}
        />
      );
    case null:
      return (
        <LocationAccessComponentDiv
          setFlow={setChosenFlow}
          setUserLoc={setUserLocation}
        />
      );
    case 'COUNTRY_SELECTOR':
      return (
        <RetailStoreListingComponentDiv
          setFlow={setChosenFlow}
          setCountry={setCountryChosen}
          chosenCountry={countryChosen}
          userLoc={userLocation}
        />
      );
    default:
      return null;
  }
};
